export default {
  main: '#ffffff',
  secondary: '#000000', //previous secondary: '#df0914',
  contrastingColor: '#000000',
  priceColor: '#EBC15B',
  entryBackground: '#ffffff',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
